module.exports = "/lucky-balls/img/bigball/BigBall_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_007.png
// module id = 902
// module chunks = 0